/** Global set by canvas-screenshot Lambda via Puppeteer `evaluateOnNewDocument` before navigation. */
export const ZENSEI_CANVAS_CAPTURE_ACCESS_TOKEN_GLOBAL =
  "__ZENSEI_CANVAS_CAPTURE_ACCESS_TOKEN__" as const;

const CAPTURE_ACCESS_TOKEN_QUERY = "capture_access_token";

/**
 * Reads and clears the Lambda-injected capture JWT (if present).
 * No-ops in SSR or when the global was not set.
 */
export function consumeCanvasCaptureInjectedAccessToken(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const w = window as unknown as Record<string, string | undefined>;
  const token = w[ZENSEI_CANVAS_CAPTURE_ACCESS_TOKEN_GLOBAL];
  if (token) {
    delete w[ZENSEI_CANVAS_CAPTURE_ACCESS_TOKEN_GLOBAL];
    return token;
  }
  return null;
}

/**
 * Reads `capture_access_token` from the current URL (local dev / `build-canvas-capture-url.mjs`),
 * removes it from the address bar, and returns the token. Lambda path uses the global instead.
 */
export function consumeCanvasCaptureAccessTokenFromUrl(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  const token = params.get(CAPTURE_ACCESS_TOKEN_QUERY);
  if (!token) {
    return null;
  }
  params.delete(CAPTURE_ACCESS_TOKEN_QUERY);
  const q = params.toString();
  const next =
    window.location.pathname +
    (q ? `?${q}` : "") +
    (window.location.hash || "");
  window.history.replaceState(window.history.state, "", next);
  return token;
}
